var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.024 15q1.013 0 1.578-.523.564-.523.564-1.465V6.988q0-.949-.534-1.468Q12.098 5 11.085 5H4.15q-.979 0-1.565.52Q2 6.04 2 6.995v6.036q0 .95.565 1.459c.565.509.905.51 1.585.51zm6.12-.923a.83.83 0 0 0 .616-.242.86.86 0 0 0 .24-.63V6.808q0-.388-.24-.627a.84.84 0 0 0-.616-.238.9.9 0 0 0-.39.09q-.198.09-.39.239l-2.28 1.853v3.763l2.28 1.86q.192.148.39.238t.39.09"
})));
export default SvgVideo;